// src/components/SystemDiagram.jsx
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function SystemDiagram({ steps }) {
  if (!steps || steps.length === 0) return null;

  return (
    <div className="bg-slate-900 rounded-3xl p-8 md:p-12 text-white relative shadow-2xl overflow-hidden border border-slate-800">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'linear-gradient(#334155 1px, transparent 1px), linear-gradient(90deg, #334155 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
      
      <div className="relative z-10">
          <div className="flex items-center justify-between mb-12">
            <h3 className="font-mono text-blue-400 text-sm uppercase tracking-[0.2em] font-bold">
                &lt;SYSTEM_FLOW /&gt;
            </h3>
            <div className="flex gap-2">
                <div className="w-2 h-2 rounded-full bg-red-500"></div>
                <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
                <div className="w-2 h-2 rounded-full bg-green-500"></div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-stretch justify-between gap-8">
             {steps.map((step, idx) => (
               <div key={idx} className="relative flex-1 flex flex-col items-center group w-full">
                  <div className="w-full h-full min-h-[100px] p-6 bg-slate-800/80 backdrop-blur-sm border border-slate-700 rounded-xl flex items-center justify-center text-center transition-all duration-300 group-hover:border-blue-600 group-hover:shadow-[0_0_20px_rgba(37, 99, 235,0.15)] z-10">
                    <span className="font-mono text-sm font-bold text-slate-200 group-hover:text-white">
                        {step}
                    </span>
                  </div>
                  {idx !== steps.length - 1 && (
                    <>
                      <div className="hidden md:flex absolute -right-6 top-1/2 -translate-y-1/2 z-0 text-slate-600 justify-center w-4">
                         <ArrowRightIcon className="w-6 h-6" />
                      </div>
                      <div className="md:hidden py-4 text-slate-600">
                         <div className="w-[1px] h-8 bg-slate-700 mx-auto"></div>
                      </div>
                    </>
                  )}
               </div>
             ))}
          </div>
      </div>
    </div>
  );
}
